import { useCallback, useEffect, useRef, useState } from 'react';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { InventoryDeeplinkQueryParam } from 'src/utils/constants/constants';
import {
  getDeepLinkIdFromUrl,
  useRemoveDeepLinkUrlPart,
} from 'src/utils/deepLinkUtils';
import { ListingDetailDataField, ListingDetails } from 'src/WebApiController';

/**
 * TODO: make it generic for POSEntity
 * @returns
 */
export const useListingInitializeFromDeeplink = () => {
  const urlInitilizedRef = useRef<boolean>(false);
  const listingInitializedRef = useRef<boolean>(false);

  const [deeplinkListing, setDeeplinkListing] = useState<ListingDetails>();
  const {
    posEntity: listing,
    posEntityId,
    setActivePosEntity,
  } = useActivePosEntityContext<ListingDetails>();

  const removeDeepLinkUrlPart = useRemoveDeepLinkUrlPart();

  useEffect(() => {
    const activeId = getDeepLinkIdFromUrl(
      InventoryDeeplinkQueryParam,
      window.location.href
    );
    if (!posEntityId && activeId && !urlInitilizedRef.current) {
      setActivePosEntity(parseInt(activeId), undefined, true, [
        ListingDetailDataField.Basic,
      ]);
      urlInitilizedRef.current = true;
    }
  }, [posEntityId, setActivePosEntity]);

  useEffect(() => {
    if (listing && !listingInitializedRef.current) {
      setDeeplinkListing(listing);
      listingInitializedRef.current = true;
    }
  }, [listing]);

  const onCleanUpDeeplinkListingkey = useCallback(
    () => removeDeepLinkUrlPart(InventoryDeeplinkQueryParam),
    [removeDeepLinkUrlPart]
  );

  return {
    deeplinkListing,
    onCleanUpDeeplinkListingkey,
  };
};
